import React, { useEffect } from 'react'
import { Wrapper, Container, Scroll, Page } from './style'
import Sidebar from '../../components/sidebar/Sidebar'

interface ILayout {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}

function Layout(props: ILayout) {
  useEffect(() => {
    if (document.readyState === 'complete') setZoom()
  })

  useEffect(() => {
    window.addEventListener('resize', setZoom)
    return () => {
      window.removeEventListener('resize', setZoom)
    }
  }, [])

  const setZoom = () => {
    const mainPage: any = document.getElementById('main')
    const width = window.innerWidth - 75
    if (width <= 1365 && mainPage) {
      const zoom = (width * 100) / 1365
      mainPage.style.zoom = `${zoom > 25 ? zoom : 25}%`
    } else {
      mainPage.style.zoom = '100%'
    }
  }

  return (
    <Wrapper dir="rtl">
      <Sidebar />
      <Container>
        <Scroll>
          <Page id="main">{props.children}</Page>
        </Scroll>
      </Container>
    </Wrapper>
  )
}

export default Layout
